import axios from "axios";
//
// export const BaseUrl = axios.create({ baseURL: `http://localhost:8080/` });
export const BaseUrl = axios.create({
    baseURL: `https://ecpbackend.amsindia.net/`,
});
